// Segmented eyebrow+title tabs — the toggle the scope overview uses for its
// Trace log / Execution log switcher (and the Inventory page's Endpoints tab).
// Each tab is a cell with a small-caps eyebrow over a title; the active cell
// sits on the page background and masks the baseline hairline so it reads as
// "in front". Tabs: [{ id, eyebrow, title, align? }]; `align: "right"` sets a
// cell's label against its right edge, for a trailing tab that stands apart
// from the rest. `onSelect(id)` optional (a single tab can render static). Extracted so the scope overview, inventory, and the
// memory store share one implementation instead of re-rolling the look.
export default function SegmentedTabs({ tabs, active, onSelect }) {
  return (
    <div
      className="relative grid items-stretch gap-[2px]"
      style={{ gridTemplateColumns: `repeat(${tabs.length}, 1fr)` }}
    >
      <span className="pointer-events-none absolute inset-x-0 bottom-0 h-[1px] bg-[color:var(--line)]" aria-hidden="true" />
      {tabs.map((t) => {
        const isActive = t.id === active;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onSelect?.(t.id)}
            className={[
              "relative grid gap-[2px] border border-b-0 px-[11px] py-[8px] cursor-pointer",
              t.align === "right" ? "text-right" : "text-left",
              isActive
                ? "border-[color:var(--line-strong)] bg-[color:var(--bg)]"
                : "border-[color:var(--line)] bg-[color:var(--control-bg)]",
            ].join(" ")}
          >
            {isActive && <span className="pointer-events-none absolute inset-x-0 bottom-0 h-[1px] bg-[color:var(--bg)]" aria-hidden="true" />}
            <span className={["text-[11px] leading-[1.1] tracking-[0.06em] uppercase", isActive ? "text-[color:var(--eyebrow)]" : "text-[color:var(--muted)]"].join(" ")}>{t.eyebrow}</span>
            <span className={["text-[14px] leading-[1.06] font-medium tracking-[-0.04em]", isActive ? "text-[color:var(--ink)]" : "text-[color:var(--muted)]"].join(" ")}>{t.title}</span>
          </button>
        );
      })}
    </div>
  );
}
